import { render, staticRenderFns } from "./ProductCategoriesEdit.vue?vue&type=template&id=8b226f7a&"
import script from "./ProductCategoriesEdit.vue?vue&type=script&lang=js&"
export * from "./ProductCategoriesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports